import ThumbnailsPanel from './ThumbnailsPanel';

export default ThumbnailsPanel;